import React from 'react';
import { Grid, Column, Tile, Button, Heading, Stack, Layer, Breadcrumb, BreadcrumbItem } from '@carbon/react';
import styles from './PricingPage.module.scss';
import { ArrowRight } from '@carbon/icons-react';
import { MarketingVariant } from '../../routes/MarketingRouter';
import MarketingHeader from '../../components/marketing/MarketingHeader';
import MarketingFooter from '../../components/marketing/MarketingFooter';
import PricingSection from '../../components/marketing/PricingSection';

interface PricingPageProps {
  variant?: MarketingVariant;
}

const PricingPage: React.FC<PricingPageProps> = ({ variant = 'default' }) => {
  const handlePricingInteraction = (plan: string) => {
    // Track pricing interaction
    console.log(`Pricing interaction: ${plan} for ${variant}`);
  };

  return (
    <div className={styles.pricingPage}>
      <MarketingHeader variant={variant} />

      {/* Breadcrumb Navigation */}
      <Grid narrow>
        <Column lg={16} md={8} sm={4} className={styles.breadcrumbContainer}>
          <Breadcrumb noTrailingSlash aria-label="Page navigation">
            <BreadcrumbItem href="/">Home</BreadcrumbItem>
            <BreadcrumbItem href="/pricing" isCurrentPage>
              Pricing
            </BreadcrumbItem>
          </Breadcrumb>
        </Column>
      </Grid>

      {/* Hero Section */}
      <Layer>
        <Grid narrow>
          <Column lg={16} md={8} sm={4}>
            <Stack gap={8} className={styles.heroSection}>
              <Stack gap={4}>
                <Heading className="cds--type-expressive-heading-06">Simple, Transparent Pricing</Heading>
                <p className={`cds--type-body-02 ${styles.heroDescription}`}>
                  Flexible pricing designed specifically for{' '}
                  {variant === 'default' ? 'educational institutions' : `${variant}s`}
                </p>
              </Stack>
              <Button kind="primary" size="lg" renderIcon={ArrowRight}>
                Start Free Trial
              </Button>
            </Stack>
          </Column>
        </Grid>
      </Layer>

      {/* Include full pricing section */}
      <PricingSection variant={variant} onPricingInteraction={handlePricingInteraction} />

      <MarketingFooter />
    </div>
  );
};

export default PricingPage;
